<template>
  <div class="actions-container">
    <a-popover
      trigger="click"
      placement="leftTop"
      overlayClassName="actions-popover"
      :arrow="false"
      :visible="visible"
      @visibleChange="visible = $event"
    >
      <span
        class="material-icons-round"
        style="cursor: pointer; font-size: 1.5rem;"
        @click.stop
      >
        more_vert
      </span>

      <template slot="content">
        <div>

          <template v-for="(action, index) in visibleActions">

            <div
              v-if="action.divider"
              :key="'divider-' + index"
              class="dropdown-divider"
            ></div>

            <a
              v-else-if="action.href"
              :key="`link-${index}`"
              :href="action.href"
              :target="action.target || '_self'"
              style="text-decoration: none;"
            >
              <div
                class="dropdown-item"
                :class="action.class"
              >
                <template v-if="action.loading">
                  <span class="material-icons-round am-spin-icon">refresh</span>
                </template>
                <template v-else-if="action.icon">
                  <span
                    v-if="!isFontAwesome(action.icon)"
                    :class="getIconClass(action)"
                  >
                    {{ action.icon }}
                  </span>

                  <i
                    v-else
                    :class="getIconClass(action)"
                  />
                </template>

                {{ action.label }}
              </div>
            </a>

            <a-tooltip
              v-else
              :key="`action-${index}`"
              :title="action.tooltip"
              placement="left"
            >
              <div
                class="dropdown-item"
                :class="[
                  action.class,
                  { disabled: action.disabled || action.loading, 'has-tooltip': !!action.tooltip }
                ]"
                @click="handleClick(action)"
              >
                <template v-if="action.loading">
                  <span class="material-icons-round am-spin-icon">refresh</span>
                </template>
                <template v-else-if="action.icon">
                  <span
                    v-if="!isFontAwesome(action.icon)"
                    :class="getIconClass(action)"
                  >
                    {{ action.icon }}
                  </span>

                  <i
                    v-else
                    :class="getIconClass(action)"
                  />
                </template>

                {{ action.label }}
              </div>
            </a-tooltip>

          </template>

        </div>
      </template>
    </a-popover>
  </div>
</template>

<script>
export default {
  name: 'ActionMenu',

  props: {
    actions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      visible: false
    }
  },

  computed: {
    visibleActions() {
      return this.actions.filter(action => action.visible !== false);
    }
  },

  methods: {
    handleClick(action) {
      if (action.disabled || action.loading) return;

      this.visible = false;

      if (typeof action.onClick === 'function') {
        action.onClick();
      }

      this.$emit('click', action);
    },
    isFontAwesome(icon) {
      return /^(fa|fas|far|fal|fab)\b/.test(icon);
    },

    getIconClass(action) {
      if (this.isFontAwesome(action.icon)) {
        return [action.icon, action.iconClass];
      }

      return ['material-icons-round', action.iconClass];
    }
  }
};
</script>
<style lang="css" scoped>
.actions-container {
  position: relative;
  display: flex;
  justify-content: center;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.9em;
  color: #605f5f;
}

.dropdown-item:hover {
  background: #f7f7f7;
}

.dropdown-item.disabled.has-tooltip {
  pointer-events: auto;
  cursor: not-allowed;
  background: transparent;
}

.dropdown-item span,
.dropdown-item i {
  font-size: 1.5em;
}

.action-primary {
  color: var(--primary-color);
}

.action-info {
  color: #2fa7ba;
}

.action-warning {
  color: #f69250;
}

.action-success {
  color: #30aa4c;
}

.action-danger {
  color: #ff0000;
}

.action-teal {
  color: lightseagreen;
}

.action-yellow {
  color: #ffca2b;
}

.am-spin-icon {
  animation: am-spin 1s linear infinite;
}

@keyframes am-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>